export default {
	relation:"",
	pcb_params:{
		level: 1,
		pcbfile:'', //歷史訂單gerberview文件
		pid:'',//gerberview上傳文件解析成功后
		history_pcb_order_sn:0,
		blind: 0, //HDI
		pbnum: 1,//拼版款数
		isgerber:1,
		plate_type:  'Fr-4',//默认defaultValue.plate_type || Material	
		thermalc:'1.0', //Thermal Conductivity
		rogers:'Rogers 4003C',  //Rogers
		board_tg: 'TG130', // TG defaultValue.board_tg ||
		units:1,
		blayer: 2, //Layer CountdefaultValue.blayer
		bwidth: '',// v-model长defaultValue.bwidth
		blength: '',//v-model宽defaultValue.blength
		layoutx: '',//defaultValue.layoutx || 
		layouty:  '',//defaultValue.layouty ||
		sidedirection: 'N/A',//defaultValue.sidedirection || 工艺边框方向
		sidewidth:  5,//defaultValue.sidewidth ||工艺边框宽度
		bheight: '1.6',//板子厚度defaultValue.bheight
		color: 'Green',//阻焊颜色defaultValue.color || 
		charcolor :'White',//字符颜色
		copper :1,//铜箔厚度defaultValue.copper || 
		insidecopper: 0,//defaultValue.insidecopper ||内层铜厚
		lineweight: 6, //最小线宽/线距
		vias:0.3, //Min. Drilled Hole
		zknum: 0,//孔密度/半孔
		cjarea: 0,//沉金面积
		cover:'Tenting Vias',//阻焊覆盖
		spray:'HASL',//焊盘喷镀 defaultValue.spray || 
		cjh:  '1',//defaultValue.cjh ||
		beveledge:  0, //金手指斜边defaultValue.beveling ||
		impendance :  0,//阻抗defaultValue.impendance ||
		via_in_pad :  "N/A",
		testpoint:  0 , //测试点数defaultValue.testPoints ||				
		test :'Sample Test Free',//飞针测试'Sample Test Free'
		bankong:'',
		baobian: '', // 包边
		pressing: '', // 叠层结构
		bcount: '',//板子数量defaultValue.blength
		pcscount: 2, //板子数量2
		//dieceng: "Stacking according to factory design", //叠层结构
		slice_report: 0, //产品报告
		shipment_report: 0,//出货报告
		report_type: 0,
		has_period: 2,
		period_format:0, // 0 是否，原来默认是2
		film_report: 0, // 实物菲林
		pcb_po_number:'',
		pcb_note:'',
		review_file: 0,
		cross_board: 1, // 打叉板
		user_stamp: 1, // 加客编，1无要求 2指定位置加客编 3不加客编
		paper: 1, // 隔白纸，1无需 2需要
		file_standard: 2, // 资料类别/文件标准 0未设置 1标准 2非标准
		acceptance: 1, // 验收标准，1IPC二级标准 2IPC三级标准 3客户指定标准
		invoice: '', // 发票,默认不需要发票 No Need 前端不设置默认值，使用后端默认值
		show_step: 0, // 1 显示阶梯价
		pad_width: '', // 焊盘宽度默认为空
		eq_mode: 0, // eq模式
		plug_in_holes: 0, //插件孔 1有,0无(默认) 铝基板
		luocheng: 0 // 锣程米数
	},
	pcb_high_params:{
		level: 2,
		pcbfile:'', //歷史訂單gerberview文件
		pid:'',//gerberview上傳文件解析成功后
		history_pcb_order_sn:0,
		blind: 0, //HDI
		pbnum: 1,//拼版款数
		isgerber:1,
		plate_type: 'Fr-4',//默认defaultValue.plate_type || Material	
		material_code: '', // 板材型号
		board_brand: '无要求', // 板材品牌
		board_tg: '', // TG defaultValue.board_tg ||
		units:1,
		blayer: 2, //Layer CountdefaultValue.blayer
		bwidth: '',// v-model长defaultValue.bwidth
		blength: '',//v-model宽defaultValue.blength
		layoutx: '',//defaultValue.layoutx || 
		layouty:  '',//defaultValue.layouty ||
		sidedirection: 'N/A',//defaultValue.sidedirection || 工艺边框方向
		sidewidth:  5,//defaultValue.sidewidth ||工艺边框宽度
		bheight: '1.6',//板子厚度defaultValue.bheight
		color: 'Green',//阻焊颜色defaultValue.color || 
		charcolor :'White',//字符颜色
		copper :1,//铜箔厚度defaultValue.copper || 
		insidecopper: 0,//defaultValue.insidecopper ||内层铜厚
		lineweight: 6, //最小线宽/线距
		vias:0.3, //Min. Drilled Hole
		zknum: 0,//孔密度/半孔
		cjarea: 0,//沉金面积
		cover:'Tenting Vias',//阻焊覆盖
		spray:'HASL',//焊盘喷镀 defaultValue.spray || 
		cjh: 0,//defaultValue.cjh ||
		beveledge:  0, //金手指斜边defaultValue.beveling ||
		impendance :  0,//阻抗defaultValue.impendance ||
		via_in_pad :  "N/A",
		testpoint:  0 , //测试点数defaultValue.testPoints ||				
		test :'Sample Test Free',//飞针测试'Sample Test Free'
		bankong: 0,
		baobian: 0, // 包边
		pressing: '', // 叠层结构
		bcount: '',//板子数量defaultValue.blength
		pcscount: 2, //板子数量2
		//dieceng: "Stacking according to factory design", //叠层结构
		slice_report: 1, //产品报告
		shipment_report: 1,//出货报告
		report_type: 2, // 报告类型 默认纸质
		has_period: 2,
		period_format:0, // 0 是否，原来默认是2
		film_report: 0, // 实物菲林
		pcb_po_number:'',
		pcb_note:'',
		review_file: 2, // 生产稿确认 2- 需要 0-不需要
		cross_board: 1, // 打叉板
		// user_stamp: 1, // 加客编，1无要求 2指定位置加客编 3不加客编
		paper: 1, // 隔白纸，1无需 2需要
		file_standard: 2, // 资料类别/文件标准 0未设置 1标准 2非标准
		acceptance: 1, // 验收标准，1-IPC二级标准,2-IPC三级标准,3-客户指定标准,4-IATF16949,5-ISO13485'
		invoice: '增票全电', // 发票,默认不需要发票 No Need 前端不设置默认值，使用后端默认值
		show_step: 0, // 1 显示阶梯价
		pad_width: '', // 焊盘宽度默认为空
		eq_mode: 3, // eq模式
		luocheng: 0, // 锣程米数
		electrogilding_thickness: '', // 电金厚度
		carbon_ink: 0, // '碳油：0-无,1-有',
		countersink: 0, // '沉头孔：0-无,1-有',
		black_fr4: 0, // 'FR4黑芯：0-无,1-有',
		embedded_copper: 0, // '埋铜块：0-无,1-有',
		cavity: 0, // '槽孔板：0-无,1-有',
		semi_flex: 0, // '半软板：0-无,1-有',
		whole_partially_hybrid: 0, // '混压：0-无,1-有',
		back_drill: 0, // '背钻孔：0-无,1-有',
		leadless_part_gold: 0, // '无引脚部分镀硬金：0-无,1-有',
		bonding_board: 0, // 'Bonding板：0-无,1-有',
		step_hole: 0, // '铣阶梯孔：0-无,1-有',
		step_slot: 0, // '铣阶梯槽：0-无,1-有',
		blind_slot: 0, // '盲槽：0-无,1-有',
		depth_control_milling: 0, // '控深铣：0-无,1-有',
		gold_finger: 0, // '金手指：0-无,1-有',
		gold_finger_thickness: '', // '金手指厚度(μ)',
		peelable_solder_mask: 0, // '可剥离阻焊：0-无,1-有',
		veneer_spacing_paper: 0 // '单板间隔纸：0-不需要,1-需要
	},
	fpc_params: {
		electrogilding_thickness: '', // 电金厚度
		fpc_blayer: '2',
		fpc_thickness: '0.2', // fpc板厚
		fpc_cover:'Coverlay (1-side)', // 阻焊类型
		fpc_color:'Yellow', // FPC颜色
		fpc_charcolor:'White', // FPC字符
		fpc_material: 'Adhesive ED', // FPC材料
		fpc_pi_thickness: '12.50', // PI厚度
		fpc_outsidecopper: '1/3', // FPC外层铜厚
		fpc_insidecopper: '', // FPC内层铜厚
		fpc_forming: 'Laser Forming', // 成型方式
		reinforce_steel: 0, // 钢片补强:0否,1是
		steel_thickness: '0.1', // 钢片补强厚度
		reinforce_aluminium: 0, // 铝片补强
		aluminium_thickness: '0.3', // 铝片补强厚度
		reinforce_fr4: 0, // FR4补强
		fr4_thickness: '0.1', // FR4补强厚度
		reinforce_pi: 0, // PI补强
		pi_thickness: '0.1', // PI补强厚度
		reinforce_num: 0,  // 补强数量
		tape: 0, // 背胶
		emi: '', // 电磁膜
		condresin: 0 // 导电胶
	},
	//rfpc_params
	rfpc_params: {
		//flex board
		pcscount: 2, //板子数量2
		plate_type:"Rigid-Flex board",
		//pcb param
		bheight:"1.6",
		blayer:2,
		cover:"Tenting Vias",
		copper:0.5,
		color:"Green",
		charcolor:"White",
		insidecopper:0.5,
		//end
		fpc_blayer:2,
		units:1,
		bwidth:"",
		blength:"",
		sidedirection:"N/A",
		bcount:"",
		fpc_thickness:"0.13",
		fpc_color:"Yellow",
		fpc_charcolor:"White",
		fpc_material:"Electrolytic Copper",
		fpc_forming:"Moulding",
		fpc_insidecopper:"1/3",
		fpc_outsidecopper:"1/3",
		lineweight:"6",
		vias:0.3,
		spray: "ENIG",
		cjh:"1",
		stiffener:"None",
		stiffener_thickness:"",
		tape:"None",
		emi:"None",
		test:"Flying Probe Test",
		impendance: 0,		
		layoutx: 1,
		layouty: 1,
		sidewidth: 5,		
		pcb_po_number:"",
		pcb_part_no:"",
		pcb_note:"",
		review_file: 0
	},	
	//smt需要提交的參數
	smt_params:{
		// buy_bom: 1,
		// //material_type: '',
		// patch_pad_number: '',				
		// plug_number: '',
					
		// x_ray_number: 1,
		// pcb_width: '',
		// pcb_height: '',
		// single_or_double_technique: 1,
		// need_split: 1,
		// need_conformal_coating: 0,
		
		// packing_type: 2, // 包装方式只有一种
		// craft_border_val:0,
		// need_split_val:0,
		bom_file:"",
		bom_po_number:"",
		bom_file_id:"",
		bom_part_no:"",
		bom_number:5,
		pcba_bom_id:0,
		buy_bom:1 ,// 'bom物料提供|1Turnkey|2Combo|3Kitted or Consigned|4Associated BOM Order',
		custom_pcb_ban: '',// 'pcb提供|1客供|2nextpcb提供|3Kitted or Consigned|4Associated PCB Order',
		//custom_pcb_ban2: 1,//fpc, rfpc 時
		number:'' ,// 'pcb数量',
		pcb_height:'' ,// 'pcb单片尺寸（长）',
		pcb_width:'' ,// 'pcb单片尺寸（宽）',
		single_or_double_technique: 1 ,// '单双面|1单面|2双面',
		patch_material_type : '',// '贴片物料种类',
		patch_pad_number:'' ,// '贴片焊盘数量',
		is_plug : 0,// '焊接插件料',
		plug_material_type: '', // '插件物料种类',
		plug_number:'' ,// '插件焊盘数量',
		need_split: 1 ,// '需要拆板',
		need_conformal_coating: 0 ,// '刷三防漆',
		x_ray_number: '' ,// 'X-RAY元件数量',
		x_ray_unit_number: '',// 'X-RAY单板数量',
		is_test : 0,// '功能测试',		
		smt_po_number:'',
		smt_part_no:'',
		smt_note:'',
		packing_type: 0,
		craft_border_val:0,
		need_split_val:0
	},
	smd_params:{
		stencil_type:'Stencil for Solder Paste',
		stencil_size:'370x470mm',
		stencil_side:'Top',
		stencil_num: 1,
		stencil_thickness:'0.10',
		existing_fiducials:'None',
		elec_tropolishing:'0',
		stencil_frame: 'Framework',
		printing_type: 3,
		stencil_note: '',
		stencil_po_number:'',
		smd_part_no:'',
		engineering_require: 1 // 默认1按《钢网制作规范及协议》进行制作
	},
	bom_params:{
		// bom_file:"",
		// bom_po_number:"",
		// bom_file_id:"",
		// bom_part_no:"",
		// bom_number:5
	},
	//用於判斷計價規則是否滿足可以計價
	canQuote:{
		pcb:false,
		fpc:false,
		rfpc:false,
		smt:false,
		smd:true
	},
	//物流，國家，等參數
	aside_param:{
		region_id: 211,
		service: "", //在選擇關聯訂單以及進入頁面時就要修改此值
		express: "",
		expresstime: "2-3 Days",
		country: 211,
		calc_type: 0,
		deltime:"",
		activity_code: ''
	},
	//用於保存上傳數據
	pcbSize:{
		bwidthSum:0,
		blengthSum:0,
		pcscount:0
	},
	area:0,
	//計價后的數據
	valuation:null,
	//pcb first 
	pcbFirstTips:"Print NEXTPCB logo on the PCBs",
	hasFirstTips:"",
	//物流數據
	expressList: null
}